
import { Injectable } from '@angular/core';
import { Buffer } from "buffer";

@Injectable({
    providedIn: 'root'
})
export class FiduciaryUtilsService  {

  public stringToBase64String(str: string): string {
    return (Buffer.from(str)).toString('base64');
  }

  public base64StringToString(base64Str: string): string {
    return (Buffer.from(base64Str, 'base64')).toString();
  }
  
}